import { notifySuccess } from '@omnipresentgroup/design-system';
import { useCreateContractorMutation } from '@omnipresentgroup/domains';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { environment } from '../../../environment';
import { ADD_HIRE_PATH, CONTRACTORS_PATH } from '../../constants';
import {
  AddContractorForm,
  AddContractorLiabilityShield,
  AddContractorReviewModal,
  type Step,
  Stepper,
} from './components';
import { mapAddContractorFieldsToCreateContractorRequest } from './mappers';
import type { AddContractorFields } from './types';

const STEPS: Step<AddContractorFields>[] = [
  {
    title: 'Omniprotect',
    property: 'liabilityShield',
    component: AddContractorLiabilityShield,
  },
  {
    title: 'Contractor',
    property: 'contractor',
    component: AddContractorForm,
  },
];

export const AddContractorWorkflow = ({ companyId }: { companyId: string }) => {
  const navigate = useNavigate();

  const handleBack = (_: Partial<AddContractorFields>, step?: number) => {
    if (step === 0) {
      // navigate(-1 as To, { replace: true }); //TODO: bring back when add hire page is migrated
      window.location.href = `${environment.apps.OMNIPLATFORM}${ADD_HIRE_PATH(
        companyId,
      )}?type=contractor`;
    }
  };

  const {
    mutate: createContractor,
    isPending: isCreatingContractor,
    isSuccess,
  } = useCreateContractorMutation();

  // Handle Success
  useEffect(() => {
    if (isSuccess) {
      notifySuccess({
        title: 'Your contractor has been added to the platform',
        description: `We've also invited them to finish onboarding`,
      });
      navigate(CONTRACTORS_PATH);
    }
  }, [isSuccess, navigate]);

  return (
    <Stepper<AddContractorFields, { companyId: string }>
      steps={STEPS}
      companyId={companyId}
      back={{
        handleClick: handleBack,
        disabled: isCreatingContractor,
      }}
      next={{
        loading: isCreatingContractor,
      }}
      modal={{
        component: AddContractorReviewModal,
        handleSubmit: (data) => {
          createContractor(
            mapAddContractorFieldsToCreateContractorRequest(data),
          );
        },
      }}
    />
  );
};
